import React, { Component } from "react";
import { graphql } from "gatsby";
import Layout from "../layouts";
import SEO from "../components/seo";

class Home extends Component {
  render() {
    const data = this.props.data;

    return (
      <Layout>
        <SEO
          title={data.wordpressPage.title}
          description={data.wordpressPage.excerpt}
        />
        <div
          css={{
            "@media screen and (max-width: 767px)": {
              marginLeft: 10,
              marginRight: 10
            }
          }}
        >
          <h1
            css={{
              "@media screen and (max-width: 767px)": { fontSize: "1.7rem" }
            }}
          >
            {data.wordpressPage.title}
          </h1>
          <div
            dangerouslySetInnerHTML={{ __html: data.wordpressPage.content }}
          />
        </div>
      </Layout>
    );
  }
}

export default Home;

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressPage {
      edges {
        node {
          id
          title
          excerpt
          slug
          date(formatString: "MMMM DD, YYYY")
        }
      }
    }
    allWordpressPost(sort: { fields: [date] }) {
      edges {
        node {
          title
          excerpt
          slug
          ...PostIcons
        }
      }
    }
    wordpressPage(wordpress_id: { eq: 5 }) {
      id
      title
      excerpt
      content
    }
  }
`;
